import { Modal } from "antd"
import styled from "styled-components"
export const ModalWrap = styled(Modal)`
  /* & .ant-modal{
    top: 0;
  } */
  & .ant-modal-content{
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;

    .ant-modal-body{
        flex: 1;
        position: relative;
        padding-bottom: 40px;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;

        .source-tabs{
          .ant-tabs-nav{
            margin-bottom: 0;
          }

          .ant-tabs-nav::before{
            border-bottom: none;
          }

          .ant-tabs-tab-btn{
            color: inherit;
          }

          .ant-tabs-tab:hover,
          .ant-tabs-tab:focus-within,
          .ant-tabs-tab:active,
          .ant-tabs-tab-active{
            &[data-node-key="X"]{
              color: #d48806;
            }

            &[data-node-key="T"]{
              color: #7a294f;
            }

            &[data-node-key="B"]{
              color: #722ed1;
            }
          }

          &.source-tabs-X .ant-tabs-ink-bar{
            background: #d48806;
          }

          &.source-tabs-T .ant-tabs-ink-bar{
            background: #7a294f;
          }

          &.source-tabs-B .ant-tabs-ink-bar{
            background: #722ed1;
          }

          .ant-tabs-ink-bar-animated{
            transition-property: width, left, right, background-color;
            /* Keep the previous color until the slide transition finishes. */
            transition-timing-function: ease, ease, ease, step-end;
          }
        }

        .step-content{
          box-sizing: border-box;
          flex: 1;
          width: 100%;
          padding-top: 6px;
          overflow: hidden;
        }

        .spin-container{
          width: 100%;
          height: 100%;
        }
    }
  }
`

export const DataWrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;

  .data-container{
    width: 100%;
  }

`
